<template>
  <div>
    <div v-if="!lockAll" class="trigger-configuration">
      <div class="trigger-show trigger-fields">
        <div class="trigger-title">
          <h5>{{ triggerConfigName }} / {{triggerInfo}}</h5>
          <p>{{ trigger.triggercode }}</p>
          <b-form-checkbox id="active-trigger" v-model="triggerActive" @change="changeActive" :checked="true" :unchecked-value="false" switch>{{ $t('ativar-gatilho') }}</b-form-checkbox>
          <hr>
          <div v-if="trigger.triggercode == 'VLV'">
            <div>
              <b-form-checkbox id="active-minimum" v-model="trigger.minActive" switch>{{ $t('ativar-limite-minimo-manual') }}</b-form-checkbox>
              <b-form-input id="minimum-value" :disabled="!trigger.minActive" @change="verfiyLimits" v-model="trigger.minValue" size="sm" type="number"></b-form-input>
            </div>
            <div>
              <b-form-checkbox id="active-maximum" v-model="trigger.maxActive" switch>{{ $t('ativar-limite-maximo-manual') }}</b-form-checkbox>
              <b-form-input id="maximum-value" :disabled="!trigger.maxActive" @change="verfiyLimits" v-model="trigger.maxValue" size="sm" type="number"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'VFR'">
            <div>
              <label for="vfr-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input id="vfr-unconformities" v-model="trigger.unconformities" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'VLT'">
            <div>
              <label for="vlt-unconformities">{{ $t('tempo-sem-atingir-meta-min') }}</label>
              <b-form-input id="vlt-unconformities" v-model="trigger.minutes" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'ATS'">
            <div>
              <label for="ats-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input id="ats-unconformities" v-model="trigger.unconformities" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'ADI'">
            <div>
              <label for="adi-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input id="adi-unconformities" v-model="trigger.unconformities" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'ATM'">
            <div>
              <label for="atm-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input id="atm-unconformities" v-model="trigger.unconformities" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'VMD'">
            <div>
              <label for="vmd-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input id="vmd-unconformities" v-model="trigger.unconformities" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
          <div v-if="trigger.triggercode == 'VMT'">
            <div>
              <label for="vmt-unconformities">{{ $t('nao-conformidades') }}</label>
              <b-form-input id="vmt-unconformities" v-model="trigger.unconformities" size="sm" type="number" min="1"></b-form-input>
            </div>
          </div>
        </div>
        <b-card class="trigger-info" border-variant="secondary" :header="triggerInfo" header-border-variant="secondary" align="center">
          <b-card-text>{{tirggerMessage}}</b-card-text>
        </b-card>
      </div>
      <b-list-group >
        <b-list-group-item 
          v-for="trigger, index in triggers" :key="index" 
          :id="trigger.triggercode"
          href="#"
          @click="selectTab"
          :title="trigger.name"
          :class="{'trigger-tab': true, 'selected': trigger.triggercode == triggerSelected}">
          {{ trigger.triggercode }}
          <span
            :title="(trigger.active ? $t('gatilho-ativo') : $t('gatilho-desativado'))" 
            :class="{'active': trigger.active, 'selected': trigger.selected}"></span>
        </b-list-group-item>
      </b-list-group>
    </div>
    <div v-else class="lock-all">
      <h5><b-icon class="mr-2" icon="gear"></b-icon>{{$t("click-em-um-grupo-de-gatilhos-configurado")}}</h5>
    </div>
  </div>
</template>

<script>
import { showError } from '../../../../../../global';
import Mediator from '../../../utilities/Mediator';
import MediatorTrigger from './../MediatorTrigger';

export default {
  name:"Trigger-Configuration",
  components: { },

  data() {
    return {
      triggerConfigName: this.$t('processo-x-greater-than-moagem'),
      triggers: [],
      lockAll: true,
      triggerInfo: this.$t('limite-de-valor'),
      tirggerMessage: this.$t('cria-ocorrencia-sempre-que-um-dos-limites'),
      triggerSelected: "VLV",
      triggerActive: false,
      trigger: {
        triggercode: "VLV",
        active: false,
        // VLV
        minValue: 0,
        maxValue: 0,
        minActive: false,
        maxActive: false,
        // VLT
        minutes: 5,
        unconformities: 1,
      },
    }
  },

  methods: {
    verfiyLimits(){
      if(!this.trigger.minActive || !this.trigger.maxActive || this.trigger.minValue <= this.trigger.maxValue) return

      let lowLimit = Math.min(this.trigger.minValue, this.trigger.maxValue)
      let maxLimit = Math.max(this.trigger.minValue, this.trigger.maxValue)
      this.trigger.minValue = lowLimit
      this.trigger.maxValue = maxLimit
      showError(this.$t('atencao-limite-minimo-deve-ser-menor-que-o-limite-maximo'))
    },

    changeActive(){
      setTimeout(() => {
        this.trigger.active = this.triggerActive
        MediatorTrigger.notify(this.triggerActive, "active-trigger")
      }, 250);
    },

    selectTab(trigger){
      if(!trigger.target || !trigger.target.id) return
      this.setInfo(this.triggersInfo.find(i => trigger.target.id == i.triggercode))
      this.setTrigger(trigger.target.id)
      MediatorTrigger.notify(trigger ,"selected-trigger")
    },

    setInfo(info){
      this.triggerInfo = info.name
      this.tirggerMessage = info.description
    },

    setTrigger(triggercode){
      this.trigger = this.triggers.find(t => t.triggercode == triggercode)
      this.triggerActive = this.trigger.active
    },

    init(){
      this.triggersInfo = Mediator.data.indicatorTriggers
      MediatorTrigger.notify(this, "init-config-trigger")
    }
  },

  mounted() {
    this.init()
  },
}
</script>

<style scoped>
.trigger-configuration{
  display: grid;
  grid-template-columns: calc(100% - 100px) 100px;
  height: 100%;
}

.trigger-tab{
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 700;
  color: #0008 !important;
}

.trigger-tab > span{
  display: block;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 1px solid #999;
  background-color: #bbb;
  margin: 0 4px;
  cursor: default;
}

.trigger-tab>.active{
  border: 1px solid #0b0;
  background-color: #0f0;
}

.trigger-tab.selected{
  border: none;
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
  color: #ff5f00 !important;
  background-color: inherit;
  font-weight: 700;
  border: 1px solid #00000010;
  border-left: none;
  border-top-left-radius: 4px;
  border-bottom-right-radius: 4px;
}

.trigger-title>h5{
  margin-bottom: 0;
}

.trigger-title>p{
  margin-bottom: 0.5rem;
  font-weight: 400;
}

.trigger-show{
  display: grid;
  grid-template-rows: 25vh 25vh;
  padding: 0px 8px 0 0;
}

.trigger-info{
  margin: 20px 20px 0 20px;
}

.lock-all{
  display: table;
  text-align: center;
  height: 100%;
}

.lock-all>h5{
  display: table-cell;
  height: inherit;
  vertical-align: middle;
}

.button-pentagro{
  align-self: flex-end;
  width: 69px;
  margin: 0px 8px 5px 0;
}

.trigger-fields>div>div>div{
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 8px;
}
.trigger-fields input{
  max-width: 250px;
}
</style>